import { buildRoleSet } from '../../reducers/users/roles';
import { _noOpProvider } from './base-provider';
let dataDogUserId = '';
const DD_SESSION_KEYS = {
    USER: '_dd_user',
    USER_ATTRS: '_dd_user_attrs'
};
const stubbedRUM = {
    startView: ()=>{
        console.log('DataDog Rum not defined: startView not initialized');
    },
    setUser: ()=>{
        console.log('DataDog Rum not defined: setUser not initialized');
    },
    setUserProperty: ()=>{
        console.log('DataDog Rum not defined: setUserProperty not initialized');
    },
    reset: ()=>{
        console.log('DataDog Rum not defined: reset not initialized');
    },
    addAction: ()=>{
        console.log('DataDog Rum not defined: addAction not initialized');
    }
};
export const getRUM = ()=>{
    return window.DD_RUM || stubbedRUM;
};
export const dataDogFactory = (dataDogViewMatchers)=>{
    const getDataDogViewDescription = (url)=>{
        for (const { pattern, getDescription } of dataDogViewMatchers){
            const matches = pattern.exec(url);
            if (matches) {
                return getDescription(matches);
            }
        }
        return null;
    };
    /**
   * Sets the given properties on the RUM session.
   * @param entries
   */ const setRUMUserProps = (entries)=>{
        Object.entries(entries).forEach(([key, value])=>{
            getRUM().setUserProperty(key, value);
        });
    };
    /**
   * Pickles the given entries into session storage under the given key.
   * Merges new entries with existing entries.
   * @param key
   * @param entries
   */ const pickleSessionProps = (key, entries)=>{
        let sessionData = sessionStorage.getItem(key) ?? '{}';
        sessionData = {
            ...JSON.parse(sessionData),
            ...entries
        };
        sessionStorage.setItem(key, JSON.stringify(sessionData));
    };
    // hydrate properties if they exist in session storage
    // this is necessary, because there are page reloads
    // _after_ the user has switched contexts
    const initialUserInfo = sessionStorage.getItem(DD_SESSION_KEYS.USER);
    if (!initialUserInfo) {
        // just to make sure that we dont have any stale data
        sessionStorage.removeItem(DD_SESSION_KEYS.USER_ATTRS);
    } else {
        getRUM().setUser(JSON.parse(initialUserInfo));
        const initialUserAttrs = sessionStorage.getItem(DD_SESSION_KEYS.USER_ATTRS);
        if (initialUserAttrs) {
            try {
                const userAttrs = JSON.parse(initialUserAttrs);
                setRUMUserProps(userAttrs);
            } catch (e) {
            // silently fail if the user attributes are not valid JSON
            }
        }
    }
    return {
        ..._noOpProvider,
        handleLocationChange: (location)=>{
            const viewDescriptor = getDataDogViewDescription(location.pathname);
            if (viewDescriptor) {
                getRUM().startView(viewDescriptor);
            }
        },
        setContext: (context)=>{
            const activeContext = context.activeContext ?? {};
            const userAttributes = {
                roles: buildRoleSet(context),
                healthSystem: activeContext.healthSystemCode,
                organization: activeContext.organizationCode,
                organizationType: activeContext.organizationType
            };
            setRUMUserProps(userAttributes);
            pickleSessionProps(DD_SESSION_KEYS.USER_ATTRS, userAttributes);
        },
        setUser: (user)=>{
            if (dataDogUserId === user.userId) {
                return;
            }
            dataDogUserId = user.userId;
            const userInfo = {
                id: user.id,
                name: user.firstName + ' ' + user.lastName,
                email: user.username
            };
            getRUM().setUser(userInfo);
            sessionStorage.setItem(DD_SESSION_KEYS.USER, JSON.stringify(userInfo));
        },
        setServiceLine: (serviceLine)=>{
            const serviceLineInfo = {
                serviceLine: serviceLine?.name ?? '',
                displayServiceLine: serviceLine?.displayName ?? ''
            };
            setRUMUserProps(serviceLineInfo);
            pickleSessionProps(DD_SESSION_KEYS.USER_ATTRS, serviceLineInfo);
        },
        trackView: (viewName)=>{
            getRUM().startView(viewName);
        },
        trackAction: (action, data)=>{
            // Implementation for tracking actions
            getRUM().addAction(action, data);
        },
        reset: ()=>{
            dataDogUserId = '';
        }
    };
};
